import './DeleteId.scss';
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import TermsAgreementInfo from './TermsAgreementInfo'; // 이용약관 컴포넌트 임포트
import fnc from '../mymod/commFunction';
import * as S from '../scss/theme';
import CertPhone from './CertPhone';
import UpdatePw from './UpdatePw';

function DeleteId() {
  const svrUrl = process.env.REACT_APP_SERVER_URL;
  const navigate = useNavigate();

  const [userInput, setUserInput] = useState({
    acaCode: fnc.getCookie_public('certCode_find'),
    username: '',
    userid: '',
    phone: '',
    password: '',
  });

  const [errorMessages, setErrorMessages] = useState({});
  const [isCheckingUserid, setIsCheckingUserid] = useState(false);
  const [useridAvailable, setUseridAvailable] = useState(true);
  const [agreedTerms, setAgreedTerms] = useState(false);
  const [agreedPrivacy, setAgreedPrivacy] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isCertOk, setIsCertOk] = useState(false);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInput({
      ...userInput,
      [name]: value,
    });
  };



  const validateForm = () => {

    if (!userInput.acaCode.trim()) {
      alert('인증코드를 입력해 주세요.');
      return false;
    }

    if (!userInput.userid.trim()) {
      alert('아이디를 입력해 주세요.');
      return false;
    }

    if (!userInput.password.trim()) {
      alert('비밀번호를 입력해 주세요.');
      return false;
    }

    if (!userInput.username.trim()) {
      alert('이름을 입력해 주세요.');
      return false;
    }

    const phonePattern = /^[0-9]{10,11}$/;
    if (!userInput.phone) {
      alert( '휴대전화 번호를 입력해 주세요.');
      return false;
    } else if (!phonePattern.test(userInput.phone)) {
      alert('유효한 휴대전화 번호를 입력해 주세요.');
      return false;
    }

    
    return true;
  };


  function onClose() {
    navigate(-1);
  }

  useEffect(() => {

    if (isCertOk) {
      setIsCertOk(false);
      navigate('/findPwUpdate');
    }
  }, [isCertOk]);


  function fncInfoAca(certCode, callback) {
    fnc.sendAxios('/infoAca', { certCode }, (res) => {
      if (res && Array.isArray(res) && res[0] && res[0].acaDbName) {  
          const acaDbName = res[0].acaDbName;
          callback(acaDbName); 
      } else {
          callback(false);  
      }
    });
  }

  function onConfirm() {//확인 버튼

    if (!validateForm()) return;

    const rtn = window.confirm('계정을 정말로 삭제하시겠습니까?');
    if (!rtn) return;
    
    fncInfoAca(userInput.acaCode, (acaDbName) => {
      if (acaDbName) {    
        fncDeleteId(acaDbName);
      } else {
        alert('인증코드가 올바르지 않습니다.');
      }
    })
  }


  function fncDeleteId(acaDbName) {
    fnc.sendAxios('/kuesbFindPwIdRoutes/deleteId', {
      id: userInput.userid,   
      pw: userInput.password,
      userName: userInput.username,
      hp: userInput.phone, 
      acaDbName,
    }, (res) => {


      if (res.rowCount > 0) {
          alert('삭제가 완료되었습니다.');
          navigate('/');
      } else {
          alert('정보가 올바르지 않습니다.');
      }

    });
  }

  //===========================================================================
  return (
    <S.Section2>
    <div className='DeleteId'>
    <div className='wrap-main'>
      
      <section className='section-singnup'>
          <p className='title'>계정삭제</p>

          <article className='article-input'>   

             <div>
                <label htmlFor="userid">*인증코드</label>
                <input
                  type="text"
                  id="acaCode"
                  name="acaCode"
                  value={userInput.acaCode}
                  onChange={handleChange}
                  required
                  placeholder='인증코드를 입력해 주세요.'
                />
              </div>

              <div>
                <label htmlFor="userid">*아이디</label>
                <input
                  type="text"
                  id="userid"
                  name="userid"
                  value={userInput.userid}
                  onChange={handleChange}
                  required
                  placeholder='아이디를 입력해 주세요.'
                />
              </div>

              <div>
                <label htmlFor="password">*비밀번호</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={userInput.password}
                  onChange={handleChange}
                  required
                  placeholder='비밀번호를 입력해 주세요.'
                />
              </div>

              <div>
                <label htmlFor="username">*이름</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={userInput.username}
                  onChange={handleChange}
                  required
                  placeholder='이름을 입력해 주세요.'
                />
              </div>

              <div>
                <label htmlFor="phone">*휴대전화</label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={userInput.phone}
                  onChange={handleChange}
                  required
                  placeholder='- 없이 입력해주세요.'
                />
              </div>
              <div className='lblWarning'>
                  <p>계정삭제 시 모든 자료는 삭제됩니다.</p>
              </div>
    
          </article>

          <div className='article-termsAgreementInfo'>
            <TermsAgreementInfo />
          </div>

          <div className='article-menu'>
            <Button className='btnClose h-btn-gray' onClick={onClose}>취소</Button>
            <Button className='btnSave h-btn-red' onClick={onConfirm} >확인</Button>
          </div>
  
      </section>

      {isModal && <div className='box_modal'>
              <CertPhone setIsModal={setIsModal} title={'비밀번호 찾기'} setIsCertOk={setIsCertOk} />
      </div> }    

       
    </div>
    </div>
    </S.Section2>
  );
}

export default DeleteId;
